export var View;
(function (View) {
  View["StartingPoint"] = "StartingPoint";
  View["GuidedSetup"] = "GuidedSetup";
  View["None"] = "None";
})(View || (View = {}));
export var isHrefMenuItem = function isHrefMenuItem(item) {
  return Boolean(item.href);
};
export var isClickMenuItem = function isClickMenuItem(item) {
  return Boolean(item.onClick);
};
export var ExperimentVariant;
(function (ExperimentVariant) {
  ExperimentVariant["DrillDownMenu"] = "create-18931-create-survey--drill-down";
  ExperimentVariant["SingleLevelMenu"] = "create-18931-create-survey--single-level";
})(ExperimentVariant || (ExperimentVariant = {}));
export var ClickMetricEventName;
(function (ClickMetricEventName) {
  ClickMetricEventName["StartFromScratch"] = "Start with a blank survey";
  ClickMetricEventName["CopyAndPaste"] = "Copy and paste from doc";
  ClickMetricEventName["Solution"] = "Insights solutions";
  ClickMetricEventName["BuildItForMe"] = "In-product guidance";
  ClickMetricEventName["Template"] = "Popular template";
  ClickMetricEventName["Audience"] = "Buy targeted responses";
})(ClickMetricEventName || (ClickMetricEventName = {}));
//# sourceMappingURL=types.js.map